<template>
  <div class="frm_content">
    <div>
      <!-- <div class="modal-dialog"> -->
        <!-- <div> -->
          <IndexSelection @queryDetail="getQuery" v-if="toggleForm" :position="indexPostion"/>
          <div class=" d-flex justify-content-between align-items-center">
            <h5 class="frm_heading">{{title}}</h5>
            <box-icon title="Detail Mode" name="window-alt" class="box-icon" @click="toggleEditMode"/>
          </div>
          <!-- <div class="modal-body"> -->
            <!-- A bootstrap form with single input field and textarea -->
            <div class="input-group mb-3">
              <span class="input-group-text" id="inputGroup-sizing-default">Label</span>
              <input type="text" v-model.lazy="formData.label" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="inputGroup-sizing-default">Type</span>
              <select
                class="form-select form-select lang-select"
                aria-label="Description Modes"
                v-model="shape"
                title="Change Modes"
              >
                <option
                  class="mode-select__option"
                  v-for="option in modeList"
                  :value="option"
                  :key="option"
                >
                  {{ option }}
                </option>
              </select>
              <!-- <input type="text" v-model.lazy="formData.type" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default"> -->
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="inputGroup-sizing-default">Color</span>
              <color-picker v-model="color" :value="color" />
              <!-- <input type="text" v-model.lazy="formData.style.fill" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default"> -->
            </div>
            <div class="input-group mb-3">
              <span class="input-group-text" id="inputGroup-sizing-default">Size</span>
              <input type="text" v-model="formData.size" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default" readonly>
              <input
                type="range"
                v-model="size"
                min="1"
                max="200"
                class="form-range ed-slider"
                id="customRange2"
              />
            </div>
            <div class="input-group">
              <span class="input-group-text">Description</span>
              <mavon-editor
                rows="4"
                id="detailEditor"
                placeholder="Add to note..."
                :showShortCut="false"
                class="mavonEditor"
                v-model="formData.description"
                :language="'en'" />
            </div>
            <div class="input-group input-group-lg">
              <span class="input-group-text" id="inputGroup-sizing-lg">Tags</span>
              <input type="text" v-model.lazy="formData.tags" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-lg">
            </div>
            <div class="d-flex justify-content-between p-2">
              <h5>Add Properties</h5>
              <div class="addProps">
                <i @click="addPropField" class='box-icon box-icon--effect bx bx-message-square-add'></i>
              </div>
            </div>
            <div id="propsRef" class="p-2" ref="propsRef">
              <div v-for="prop in propCount" :key="prop" class="d-flex flex-wrap">
                <input class="m-1 p-2" type="text" :value="prop[0]" placeholder="Enter property name">
                <input class="m-1 p-2" type="text" :value="prop[1]" placeholder="Enter property value">
              </div>
            </div>
            <!-- <div class="d-grid gap-2">
                <button class="p-2 ms-2 btn btn-sm btn-primary" @click="addPropField">Add New Property</button>
            </div> -->
          </div>
          <div class="modal-buttons">
            <button type="button" @click="onSubmit" class="ed-btn__blim ed-btn__sm modal-buttons__btn">Update</button>
            <button type="button" class="ed-btn ed-btn__sm modal-buttons__btn" @click="toggleEditMode">Close</button>
          </div>
        <!-- </div> -->
      <!-- </div> -->
    <!-- </div> -->
  </div>
</template>

<script>
import IndexSelection from '@/components/IndexSelection.vue';
import graphReactor from '@/graphReactor';

export default {
  props: {
    msgData: String,
    customId: String,
    title: String,
    formData: Object,
    toggleEditMode: Function,
  },

  components: {
    IndexSelection,
  },
  mounted() {
    this.propCount = Object.keys(this.formData.props).map((i) => [i, this.formData.props[i]]);
    document.addEventListener('mousemove', (mouseMoveEvent) => {
      console.log(mouseMoveEvent);
      this.localPostition = {
        x: mouseMoveEvent.pageX,
        y: mouseMoveEvent.pageY,
      };
      console.log(this.indexPostion);
    }, false);
    document.querySelectorAll('#detailEditor .auto-textarea-input')[0].addEventListener('keydown', (e) => {
      console.log('let me check ', this.formData.description[e.target.selectionStart]);
      if (e.keyCode === 51) {
        console.log('ctrl+g', e);
        this.indexPostion = this.localPostition;
        this.toggleForm = true;
      } else {
        this.toggleForm = false;
      }
    });
  },
  data() {
    return {
      indexPostion: {},
      toggleForm: false,
      propCount: [],
      modeList: [
        'circle',
        'ellipse',
        'rect',
        'diamond',
        'triangle',
        'star',
        'image',
        'modelRect',
        'donut',
      ],
      color: '',
      customProps: {},
      shape: this.formData.type || '',
      size: this.formData.size,
      localPostition: {},
    };
  },
  watch: {
    color(val) {
      console.log('color changed', val.hex8, this.color.hex8);
      this.formData.style.fill = val.hex8.length > 0
        ? val.hex8 : this.formData.style.fill;
      this.watchUpdate();
    },
    shape(val) {
      this.formData.type = val.length > 0 ? val : this.formData.type;
      this.watchUpdate();
    },
    size(val) {
      this.formData.size = val.length > 0 ? val : this.formData.size;
      // this.watchUpdate();
    },
    formData(val) {
      console.log('EDVANTA FORM', val);
      this.shape = val.type;
      this.formData.size = val.size || '20';
      this.color = {
        hex: '#194d33',
        hex8: val.style.fill,
        hsl: {
          h: 150,
          s: 0.5,
          l: 0.2,
          a: 1,
        },
        hsv: {
          h: 150,
          s: 0.66,
          v: 0.30,
          a: 1,
        },
        rgba: {
          r: 25,
          g: 77,
          b: 51,
          a: 1,
        },
        a: 1,
      };

      if (val.props) {
        this.propCount = Object.keys(val.props).map((i) => [i, val.props[i]]);
      } else {
        this.propCount = [];
      }

      // eslint-disable-next-line no-param-reassign
    },
  },
  methods: {
    addPropField() {
      this.propCount.push(['', '']);
    },
    getQuery(val) {
      const indexT = document.querySelectorAll('#detailEditor .auto-textarea-input')[0].selectionStart;
      console.log('indexT', indexT);
      console.log('getQuery', val, indexT, this.formData.description);
      const finalCheck = `${this.formData.description.substr(0, indexT - 1)} \n$nl [${val.label}](${val.id}) nl$\n ${this.formData.description.substr(indexT)}`;
      console.log('indexT2', [this.formData.description.substr(0, indexT - 1), this.formData.description.substr(indexT)]);
      this.formData.description = finalCheck;
      this.toggleForm = !this.toggleForm;
    },
    async emitUpdateNode() {
      this.$refs.propsRef.childNodes.forEach((i) => {
        console.log(console.log('updateNode', i));
        const ichild = i.childNodes;
        this.customProps[ichild[0].value] = {
          type: 'custom',
          value: ichild[1].value,
        };
      });
      console.log('updateNode', this.customProps);
      this.formData.props = this.customProps;
      console.log('emitUpdateNode', this.formData);
      //
      const updatedNode = graphReactor.exploreInstance.findById(this.formData.id);
      // this.formData.style.fill = this.color.hex8;
      // this.formData.type = this.shape.length > 0 ? this.shape : this.formData.type;
      updatedNode.update(this.formData);
      await this.$store.dispatch('gmodule/saveG6ExploreData');
      graphReactor.exploreInstance.updateLayout();
    },
    async watchUpdate() {
      // this.$refs.propsRef.childNodes.forEach((i) => {
      //   console.log(console.log('updateNode', i));
      //   const ichild = i.childNodes;
      //   this.customProps[ichild[0].value] = ichild[1].value;
      // });

      // this.formData.props = this.customProps;
      // console.log('emitUpdateNode', this.formData);
      //
      const updatedNode = graphReactor.exploreInstance.findById(this.formData.id);
      this.formData.style.fill = this.color.hex8;
      this.formData.type = this.shape.length > 0 ? this.shape : this.formData.type;
      updatedNode.update(this.formData);
      await this.$store.dispatch('gmodule/saveG6ExploreData');
      graphReactor.exploreInstance.updateLayout();
    },
    onSubmit() {
      this.emitUpdateNode();
      this.toggleEditMode();
    },
  },
};
</script>

<style lang="scss" scoped>
  .frm_heading{
    padding: 15px;
  }

  .addProps {
    padding: 0 10px;
    font-size: 20px;
    cursor: pointer;
    &:hover {
      transform: scale(1.1);
    }
  }
.input-group {
    padding: 10px;
}

.v-note-wrapper.shadow {
  z-index: 5!important;
}

.modal-buttons {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
  padding: 0.75rem;
  border-top: 1px solid #dee2e6;
  border-bottom-right-radius: calc(0.3rem - 1px);
  border-bottom-left-radius: calc(0.3rem - 1px);

  &__btn {
    margin-right: .75rem;
  }
}
</style>
